import React from "react";

import { useDateTranslation } from "../../../../hooks/dateTranslation";
import DropdownSelect from "../../../FormElement/DropdownSelect";
import { useFacilityReports } from "../../FacilityReportsList/hooks";

type IFacilityReportSelectProps = {
  locationId: string;
  currentReportId: number;
  onSelectId: (id: number) => void;
};

export const FacilityReportSelect: React.FunctionComponent<
  IFacilityReportSelectProps
> = (props) => {
  const { locationId, currentReportId, onSelectId } = props;

  const { translateDateRange } = useDateTranslation();

  const { query } = useFacilityReports({
    location_id: locationId,
    sort: "created_at",
    order: "desc",
    limit: 10,
    offset: 0,
    seek_total_count: false,
  });
  const facilityReports = query.data?.data;

  // Hack to use DropdownSelect, which only accepts an array of strings as items
  // So we map the timespan to an id, and return the id in the onChange handler
  const timespanIdMap: Record<string, number> = {};
  for (const report of facilityReports ?? []) {
    timespanIdMap[
      `${translateDateRange(
        // Cast to Date because the data is serialized as a string
        new Date(report.start_date),
        new Date(report.end_date)
      )}`
    ] = report.id;
  }

  const items = Object.keys(timespanIdMap);

  const onChange = (timespan: string) => {
    const id = timespanIdMap[timespan];
    // Return the id associated with the timespan
    onSelectId(id);
  };

  const selectedTimespan =
    items.find((item) => {
      return Number(timespanIdMap[item]) === Number(currentReportId);
    }) ?? "";

  return (
    <div className="facility-report-select">
      <DropdownSelect
        value={selectedTimespan}
        items={items}
        onChange={onChange}
      />
    </div>
  );
};
